require('./receivedTransfersContentHeader.scss');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');


class ReceivedTransfersContentHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    handleAccountChange(accountId) {
        this.props.history.push(`/myprofile/transfers/received/${accountId}`);
    }

    render() {
        const { immAccounts, accountId, onFilterClick } = this.props;
        const headerTitle = formatText('transfersReceived-destiny');
        const accountsIndexes = immAccounts.get('byOrder').toJS();
        return (
            <header className="received-transfers-content-header">
                <div className="clearfix received-transfers-content-header__title">
                    <div className="pull-left">
                        <OKBoxTitle value={headerTitle} />
                    </div>
                    <div className="pull-right clearfix received-transfers-content-header__filters">
                        <OKButton modifier="task" onClick={onFilterClick}>
                            <i className="icon-filtrar received-transfers-content-header__filter-icon" />
                        </OKButton>
                    </div>
                </div>
                <div className="row received-transfers-content-header__dropdown">
                    <div className="col-xs-5-cc-6">
                        <DropdownAccounts
                            immAccounts={immAccounts.get('byId')}
                            accountsIndexes={accountsIndexes}
                            currentAccountId={accountId}
                            initialAccountIndex=""
                            onAccountChange={this.handleAccountChange}
                            showAvailableBalance={true}
                        />
                    </div>
                </div>
            </header>
        );
    }
}

ReceivedTransfersContentHeader.propTypes = {
    accountId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    onFilterClick: PropTypes.func.isRequired
}

module.exports = withRouter(ReceivedTransfersContentHeader);
